// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1wRSF","content":"styles_content__2D5DT","selectAll":"styles_selectAll__3VexU"};